import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=28a1f3ae&scoped=true"
import script from "./Shadow.vue?vue&type=script&lang=js"
export * from "./Shadow.vue?vue&type=script&lang=js"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=28a1f3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1f3ae",
  null
  
)

export default component.exports